// Purpose: Person class for RegisterAlternate component

export class Person {
  id = ''
  fullName = ''
  firstName = ''
  lastName = ''
  email = ''
  mobile = ''

 /**
  * @param {Object} [person] - person object
  * */
  constructor(person = null) {
    if (!person) return

    // test values for null and undefined
    // if null or undefined, use empty string
    this.id = person.id || ''
    this.fullName = person.fullName || ''
    this.firstName = person.firstName || ''
    this.lastName = person.lastName || ''
    this.email = person.email || ''
    this.mobile = person.mobile || ''
  }
}